// extracted by css-extract-rspack-plugin
export default {"root":"Quky3","header":"RUCrJ"};